import request from '@/utils/http'

// 配置列接口
export const getList = {
    post(params) {
        return request({
            url: '/api-auth/userIndividualConfigs/saveOrUpdate',
            method: 'post',
            data: params,
        }).then(res => res)
    },
    get(params) {
        return request({
            url: '/api-auth/userIndividualConfigs/param',
            method: 'post',
            data: params,
        }).then(res => res)
    },
}
// 管理端日常考核查询接口
export const blackInfoList = params => {
    return request({
        url: `/api-srm-web/supplier/selectSupplierBlackInfoPageBySupplierBlackInfo`,
        method: 'post',
        data: params,
    })
}
// 黑名单新增接口
export const saveAndUpdateBlackInfo = data => {
    return request({
        url: `/api-srm-web/supplier/saveAndUpdateBlackInfo`,
        method: 'post',
        data,
    })
}
// 黑名单详情
export const getSupplierBlackInfoDetailById = id => {
    return request({
        url: `/api-srm-web/supplier/getSupplierBlackInfoDetailById/${id}`,
        method: 'get',
    })
}
// 拉黑附件保存
export const saveBlackFile = data => {
    return request({
        url: `/api-srm-web/supplier/saveBlackFile`,
        method: 'post',
        data,
    })
}
// 拉黑附件删除
export const deleteBlackFile = fileId => {
    return request({
        url: `/api-srm-web/supplier/deleteBlackFile/${fileId}`,
        method: 'delete',
    })
}
// 查看关联供应商
export const selectAssociatedSuppliers = data => {
    return request({
        url: `/api-srm-web/supplier/selectAssociatedSuppliers`,
        method: 'post',
        data,
    })
}
// mip流程
export const blackInfoSubmitMipApproval = data => {
    return request({
        url: `/api-srm-web/supplier/blackInfoSubmitMipApproval`,
        method: 'post',
        data,
    })
}

// 删除流程
export const deleteBlackMip = id => {
    return request({
        url: `/api-srm-web/supplier/deleteBlackMip/${id}`,
        method: 'delete',
    })
}

// 洗白-保存
export const saveWhiteReason = data => {
    return request({
        url: `/api-srm-web/supplier/saveWhiteReason`,
        method: 'post',
        data,
    })
}
// 洗白-MIP审批
export const whiteSubmitMipApproval = data => {
    return request({
        url: `/api-srm-web/supplier/whiteSubmitMipApproval`,
        method: 'post',
        data,
    })
}

// 导出
export const exportSupplierBlackInfo = data => {
    return request({
        url: `/api-srm-web/supplier/exportSupplierBlackInfo`,
        method: 'post',
        responseType: 'arraybuffer',
        data,
    })
}

// 关联企业
export const supplierBlackEnterpriseRelations = data => {
    return request({
        url: `/api-srm-web/supplier/supplierBlackEnterpriseRelations`,
        method: 'post',
        data,
    })
}

// 关联企业初始化
export const supplierBlackEnterpriseRelationInit = data => {
    return request({
        url: `/api-srm-web/supplier/supplierBlackEnterpriseRelation/initJob`,
        method: 'get',
        params: data,
    })
}

// 流程ID查询拉黑流程信息
export const getBlackAudit = data => {
    return request({
        url: `/api-srm-web/supplier/supplierBlackInfo/blackAudit`,
        method: 'get',
        params: data,
    })
}

// 流程ID查询洗白流程信息
export const getWhiteAudit = data => {
    return request({
        url: `/api-srm-web/supplier/supplierBlackInfo/whiteAudit`,
        method: 'get',
        params: data,
    })
}

// 查询拉黑范围列表
export const supplierBlackReason = data => {
    return request({
        url: `/api-srm-web/supplier/supplierBlackScopes/query`,
        method: 'post',
        data,
    })
}

// 更新数据
export const syncSupplierInfo = data => {
    return request({
        url: `/api-srm-web/supplier/supplierBlackInfo/syncSupplierInfo`,
        method: 'post',
        data,
    })
}
